export const ORIGINREASON = [
  'CUSTOMER_CARE',
  'PARTNER',
  'PRICE',
  'SERVICE_QUALITY',
  'SUPPORT'
]
